/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Row,
  Skeleton,
  // DatePicker,
  Table,
  Select,
  AutoComplete,
  Input,
  Spin,
  // Button,
} from "antd";
import "./index.css";
import { DownloadOutlined } from "@ant-design/icons";
import { BiCalendar } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
import useMedia from "use-media-antd-query";
import {
  loadStockReportList,
  // loadDashboardTransactions,
} from "../../store/reports/actions";
import DatePicker from "react-datepicker";
import { loadVendor } from "../../store/vendor/actions";
import { loadBrandList, loadItems } from "../../store/items/actions";
import api from "../../helpers";

const StockDetailsReport = (props) => {
  const dispatch = useDispatch();

  //organisation id from login response
  const userValues = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userValues);

  const organizationId =
    !isEmpty(userNameDetails) &&
    userNameDetails.user &&
    userNameDetails.user.organizations.length > 0
      ? userNameDetails.user.organizations[0].organizationId
      : "";

  const media = useMedia();

  const stockGetPayload = {
    organizationId: organizationId,
    page: 1,
    limit: 10,
  };

  console.log(userNameDetails, "userNameDetails");
  //initial state values
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [brandList, setBrandList] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setLoading(false);
    }, 2000);
    dispatch(loadStockReportList(stockGetPayload));
    dispatch(loadBrandList());
    dispatch(
      loadItems({
        organizationId: organizationId,
      })
    );
    dispatch(
      loadVendor({
        organizationId: organizationId,
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reducer state
  const { stock_report_list = {} } = useSelector((state) => state.Reports);
  const { brand_list = {}, items_list = [] } = useSelector(
    (state) => state.Items
  );
  const { vendor_list = [] } = useSelector((state) => state.Vendor);

  const vendorOptions =
    vendor_list && vendor_list.length > 0
      ? vendor_list.map((data) => {
          return { value: data._id, label: data.vendorName };
        })
      : [];
  const itemOptions =
    items_list && items_list.length > 0
      ? items_list.map((data) => {
          return { value: data._id, label: data.itemName };
        })
      : [];
  console.log(brand_list, "brand_list");

  const brandOptions =
    brand_list && brand_list.length > 0
      ? brand_list.map((data) => {
          return { value: data._id, label: data.brandName };
        })
      : [];

  //header columns
  const HeaderData = [
    {
      key: "purchaseinvoiceDate",
      title: <p className="header-purchase-invoice font-semibold">Date</p>,
      dataIndex: "purchaseinvoiceDate",
      width: 120,
      // fixed: "left",
      sorter: (a, b) =>
        a.purchaseinvoiceDate.length - b.purchaseinvoiceDate.length,
    },
    {
      key: "purchaseinvoiceNo",
      title: (
        <p className="header-purchase-invoice font-semibold">Invoice No</p>
      ),
      dataIndex: "purchaseinvoiceNo",
      width: 120,
    },
    {
      key: "vendorName",
      title: (
        <p className="header-purchase-invoice font-semibold">Vendor Name</p>
      ),
      dataIndex: "vendorName",
      width: 150,
    },
    // {
    //   key: "brandName",
    //   title: (
    //     <p className="header-purchase-invoice font-semibold">Brand Name</p>
    //   ),
    //   dataIndex: "brandName",
    //   width: 170,
    // },
    {
      key: "modelName",
      title: (
        <p className="header-purchase-invoice font-semibold">Model Name</p>
      ),
      dataIndex: "modelName",
      width: 170,
    },
    {
      key: "ramName",
      title: <p className="header-purchase-invoice font-semibold">RAM Name</p>,
      dataIndex: "ramName",
      width: 170,
    },
    {
      key: "purchasePrice",
      title: (
        <p className="header-purchase-invoice font-semibold">Purchase Price</p>
      ),
      dataIndex: "purchasePrice",
      width: 130,
    },
    {
      key: "sellingPrice",
      title: (
        <p className="header-purchase-invoice font-semibold">Selling Price</p>
      ),
      dataIndex: "sellingPrice",
      width: 120,
    },
    // {
    //   key: "products",
    //   title: <p className="header-purchase-invoice font-semibold">Items</p>,
    //   dataIndex: "products",
    // },
    // {
    //   key: "status",
    //   title: <p className="header-purchase-invoice font-semibold">Status</p>,
    //   dataIndex: "status",
    //   width: 150,
    // },
  ];

  //filters
  const [pageValue, setPageValue] = useState("");
  const [filteredValues, setFilteredValues] = useState("");
  const applyFilters = () => {
    var fromDateFilter = fromDate ? moment(fromDate).format("YYYY-MM-DD") : "";
    var toDateFilter = toDate ? moment(toDate).format("YYYY-MM-DD") : "";
    var brandId =
      brandList.length > 0
        ? brandList.map((data) => data)
        : brandList.length === 0
        ? ""
        : [];
    var modelId =
      modelList.length > 0
        ? modelList.map((data) => data)
        : modelList.length === 0
        ? ""
        : [];
    var vendorId =
      vendorList.length > 0
        ? vendorList.map((data) => data)
        : vendorList.length === 0
        ? ""
        : [];

    let searchValue = {};
    searchValue.page = pageValue ? pageValue : 1;
    searchValue.limit = 10;
    searchValue.organizationId = organizationId;

    if (fromDateFilter) {
      searchValue.fromDate = fromDateFilter;
    }
    if (toDateFilter) {
      searchValue.toDate = toDateFilter;
    }
    if (brandId) {
      searchValue.brandId = brandId;
    }
    if (modelId) {
      searchValue.modelId = modelId;
    }
    if (vendorId) {
      searchValue.vendorId = vendorId;
    }

    const searchFilterValues = Object.keys(searchValue).forEach(
      (data) => !searchValue[data] && delete searchValue[data]
    );
    setFilteredValues(searchValue);
    console.log(searchFilterValues, "searchFilterValues");
    setTableLoading(true);
    dispatch(loadStockReportList(searchValue));
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  console.log(pageValue, "pageValue");

  const [stockReportRows, setStockReportRows] = useState([
    {
      key: "",
      aging: "",
      barCodeNo: "",
      brandId: "",
      brandName: "",
      dateCreated: "",
      itemId: "",
      modelName: "",
      purchasePrice: "",
      purchaseinvoiceDate: "",
      purchaseinvoiceNo: "",
      ramName: "",
      sellingPrice: "",
      serialId: "",
      serialStatus: [],
      vendorId: "",
      vendorName: "",
    },
  ]);

  const stockReportDataTable =
    !isEmpty(stock_report_list) && stock_report_list.data.length > 0
      ? stock_report_list.data.map((data, index) => {
          return {
            key: index + 1,
            aging: data.aging ? (
              <div
                className={
                  data.aging > 30
                    ? "text-[#bb1d0d] font-semibold text-start"
                    : "text-[#08a35ae0] font-semibold text-start"
                }
              ></div>
            ) : (
              ""
            ),
            barCodeNo: data.barCodeNo,
            brandId: data.brandId,
            brandName: data.brandName,
            dateCreated: data.dateCreated,
            itemId: data.itemId,
            modelName: data.modelName,
            purchasePrice: data.purchasePrice,
            purchaseinvoiceDate: data.dateCreated
              ? moment(data.dateCreated).format("DD-MM-YYYY")
              : "",
            purchaseinvoiceNo: data.purchaseinvoiceNo,
            ramName: data.ramName,
            sellingPrice: data.sellingPrice,
            serialId: data.serialId,
            serialStatus: data.serialStatus,
            vendorId: data.vendorId,
            vendorName: data.vendorName,
            status: data.status,
          };
        })
      : [];

  console.log(stockReportDataTable, "stockReportDataTable");
  useEffect(() => {
    if (stockReportDataTable && stockReportDataTable.length > 0) {
      setStockReportRows(stockReportDataTable);
    } else {
      setStockReportRows([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stock_report_list]);

  //paginations
  const handlePagination = (data) => {
    const filter = {
      page: data,
      limit: 10,
      organizationId: organizationId,
      modelId: filteredValues ? filteredValues.modelId : "",
      vendorId: filteredValues ? filteredValues.vendorId : "",
      brandId: filteredValues ? filteredValues.brandId : "",
      fromDate: filteredValues ? filteredValues.fromDate : "",
      toDate: filteredValues ? filteredValues.toDate : "",
    };

    const searchFilterValues = Object.keys(filter).forEach(
      (data) => !filter[data] && delete filter[data]
    );
    console.log(searchFilterValues, "searchFilterValues");
    console.log(filter, "filter");
    setPageValue(data);
    dispatch(loadStockReportList(filter));
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //search , print and download
  const [search, setSearch] = useState("");

  const handleSearch = (event) => {
    const filteredRows = stockReportDataTable
      .filter((row) =>
        row.modelName.toLowerCase().includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setStockReportRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //Download functionality

  //Download functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const handleDownloadPDF = () => {
    setDownloadLoading(true);
    var brandId = brandList.length > 0 ? brandList.map((data) => data) : [];

    let searchValue = {};
    searchValue.organizationId = organizationId;

    // if (fromDateFilter) {
    //   searchValue.fromDate = fromDateFilter;
    // }
    // if (toDateFilter) {
    //   searchValue.toDate = toDateFilter;
    // }
    if (brandId) {
      searchValue.brandId = brandId;
    }
    api
      .post(`/org/filterstockexcelexport`, searchValue)
      .then((response) => {
        // console.log(response.data, "response");

        const stockReportExcel =
          !isEmpty(response) && response.data.length > 0
            ? response.data.map((data, index) => {
                return {
                  key: index + 1,
                  aging: data.aging,
                  barCodeNo: data.barCodeNo,
                  brandId: data.brandId,
                  brandName: data.brandName,
                  dateCreated: data.dateCreated,
                  itemId: data.itemId,
                  modelName: data.modelName,
                  purchasePrice: data.purchasePrice,
                  purchaseinvoiceDate: data.dateCreated
                    ? moment(data.dateCreated).format("DD-MM-YYYY")
                    : "",
                  purchaseinvoiceNo: data.purchaseinvoiceNo,
                  ramName: data.ramName,
                  sellingPrice: data.sellingPrice,
                  serialId: data.serialId,
                  serialStatus: data.serialStatus,
                  vendorId: data.vendorId,
                  vendorName: data.vendorName,
                  status: data.status,
                };
              })
            : [];
        setTimeout(() => {
          let headerData = [
            "S.No, Date,Invoice No,Vendor Name,Model Name,RAM Name,Purchase Price,Selling Price",
          ];

          let usersCsv = !isEmpty(stockReportExcel)
            ? stockReportExcel.reduce((acc, user) => {
                const {
                  key,
                  purchaseinvoiceDate,
                  purchaseinvoiceNo,
                  vendorName,
                  modelName,
                  ramName,
                  sellingPrice,
                  purchasePrice,
                } = user;
                acc.push([
                  key,
                  purchaseinvoiceDate,
                  purchaseinvoiceNo,
                  vendorName,
                  modelName,
                  ramName,
                  sellingPrice,
                  purchasePrice,
                ]);

                console.log("test", acc);
                return acc;
              }, [])
            : false;
          console.log(usersCsv, "usersCsv");

          const usersList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : [];

          downloadFile({
            data: [...headerData, ...usersList].join("\n"),
            fileName: "StockDetailsReport.csv",
            fileType: "text/csv",
          });
          setDownloadLoading(false);
        }, 2500);
        return response.data;
      })
      .catch((error) => Promise.reject(error));
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //date and iconCalendarClasses
  const dateFieldClasses =
    media == "sm"
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[200%] mt-2"
      : media == "xs"
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[125%] mt-2"
      : media == "lg" || media == "md"
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[100%]"
      : windowDimensions.width >= 1500 && windowDimensions.width < 1600
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[172%]"
      : windowDimensions.width >= 1600 && windowDimensions.width < 1700
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[178%]"
      : windowDimensions.width >= 1700 && windowDimensions.width < 1800
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[195%]"
      : windowDimensions.width >= 1800 && windowDimensions.width < 1900
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[211%]"
      : windowDimensions.width >= 1900 && windowDimensions.width < 2000
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[225%]"
      : windowDimensions.width >= 2000
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[238%]"
      : "profit-loss-label rounded-sm border border-1 h-[40px] w-[145%]";

  const iconCalendarClasses =
    media == "sm"
      ? "top-[12px] text-[16px] right-[-183px] text-[#9e9e9e]"
      : media == "xs"
      ? "top-[12px] text-[16px] right-[-30px] text-[#9e9e9e]"
      : media == "md" || media == "lg"
      ? "top-[2px] text-[16px] right-[3px] text-[#9e9e9e]"
      : windowDimensions.width >= 1500 && windowDimensions.width < 1600
      ? "top-[2px] text-[16px] right-[-128px] text-[#9e9e9e]"
      : windowDimensions.width >= 1600 && windowDimensions.width < 1700
      ? "top-[2px] text-[16px] right-[-138px] text-[#9e9e9e]"
      : windowDimensions.width >= 1700 && windowDimensions.width < 1800
      ? "top-[2px] text-[16px] right-[-158px] text-[#9e9e9e]"
      : windowDimensions.width >= 1800 && windowDimensions.width < 1900
      ? "top-[2px] text-[16px] right-[-197px] text-[#9e9e9e]"
      : windowDimensions.width >= 1900 && windowDimensions.width < 2000
      ? "top-[2px] text-[16px] right-[-218px] text-[#9e9e9e]"
      : windowDimensions.width >= 2000
      ? "top-[2px] text-[16px] right-[-228px] text-[#9e9e9e]"
      : "top-[2px] text-[16px] right-[-78px] text-[#9e9e9e]";

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Stock Details Report | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins border border-b-1 border-x-0 border-t-0 pl-[20px] pr-[20px] mt-2 pb-2">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] font-semibold"
              >
                Stock Details Report
              </h1>
            </div>
          </div>
        </Col>
      </Row>
      <Row
        className={
          windowDimensions.height >= 500 && windowDimensions.height <= 600
            ? "stock-details-report-small-device"
            : (windowDimensions.height >= 700 &&
                windowDimensions.height <= 767) ||
              (windowDimensions.height > 767 && windowDimensions.height < 830)
            ? "add-ledger-statment-reports-large-device"
            : windowDimensions.height >= 830 && windowDimensions.height <= 900
            ? "add-ledger-statment-reports-extra-large-device"
            : windowDimensions.height > 900 && windowDimensions.height <= 1000
            ? "add-ledger-statment-reports-extra-extra-large-device"
            : windowDimensions.height > 1000
            ? "add-ledger-statment-reports-infite-extra-large-device"
            : "stock-details-report-medium-device"
        }
      >
        <Col
          span={24}
          className={
            windowDimensions.height >= 550 && windowDimensions.height <= 700
              ? "mt-2 pr-4 pl-4 pt-3 pb-2 h-[35%] mb-4 bg-[#ffffff] rounded-md"
              : "mt-2 pr-4 pl-4 pt-3 pb-2 h-[25%] mb-4 bg-[#ffffff] rounded-md"
          }
        >
          <Row className="pr-2 pl-2 pt-3 pb-2 rounded-md">
            <Col md={6} lg={6} sm={12} xs={12} className="pr-3">
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                  }}
                ></Skeleton.Input>
              ) : (
                <Select
                  value={brandList}
                  onChange={(newValue) => setBrandList(newValue)}
                  placeholder="Select Brand"
                  mode="multiple"
                  options={brandOptions}
                  maxTagTextLength={11}
                  maxTagCount={"responsive"}
                  className={
                    media == "sm"
                      ? "w-[366px] h-[40px] mt-2"
                      : media == "xs"
                      ? "w-[230px] h-[40px] mt-2"
                      : "w-[100%] h-[40px]"
                  }
                  rootClassName="purchase-label"
                />
              )}
            </Col>
            <Col md={6} lg={6} sm={24} xs={24} className="pr-3">
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                    marginTop: media == "sm" || media == "xs" ? "6px" : "",
                  }}
                ></Skeleton.Input>
              ) : (
                <Select
                  value={modelList}
                  onChange={(newValue) => setModelList(newValue)}
                  placeholder="Select Model"
                  mode="multiple"
                  options={itemOptions}
                  maxTagTextLength={11}
                  maxTagCount={"responsive"}
                  className={
                    media == "sm"
                      ? "w-[366px] h-[40px] mt-2"
                      : media == "xs"
                      ? "w-[230px] h-[40px] mt-2"
                      : "w-[100%] h-[40px]"
                  }
                  rootClassName="purchase-label"
                />
              )}
            </Col>
            <Col md={6} lg={6} sm={24} xs={24} className="pr-3">
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                    marginTop: media == "sm" || media == "xs" ? "6px" : "",
                  }}
                ></Skeleton.Input>
              ) : (
                <Select
                  value={vendorList}
                  onChange={(newValue) => setVendorList(newValue)}
                  placeholder="Select Vendor"
                  mode="multiple"
                  maxTagTextLength={11}
                  maxTagCount={"responsive"}
                  options={vendorOptions}
                  className={
                    // vendorList.length >= 2
                    //   ? "w-[100%] h-[100%]"
                    //   :
                    media == "sm"
                      ? "w-[366px] h-[40px] mt-2"
                      : media == "xs"
                      ? "w-[230px] h-[40px] mt-2"
                      : "w-[100%] h-[40px]"
                  }
                  rootClassName="purchase-label"
                />
              )}
            </Col>
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={
                media === "lg" ||
                media === "xl" ||
                media === "xxl" ||
                media === "md"
                  ? "pr-3"
                  : "pr-3"
              }
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                  }}
                ></Skeleton.Input>
              ) : (
                <DatePicker
                  toggleCalendarOnIconClick={true}
                  selected={fromDate}
                  className={dateFieldClasses}
                  icon={<BiCalendar className={iconCalendarClasses} />}
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onChange={(date) => setFromDate(date)}
                  popperClassName={"z-10 ml-3"}
                  showIcon
                  placeholderText="Select From Date"
                />
              )}
            </Col>
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={
                media === "lg" ||
                media === "xl" ||
                media === "xxl" ||
                media === "md"
                  ? "mt-3 pr-3"
                  : "pr-3"
              }
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                  }}
                ></Skeleton.Input>
              ) : (
                <DatePicker
                  toggleCalendarOnIconClick={true}
                  selected={toDate}
                  className={dateFieldClasses}
                  icon={<BiCalendar className={iconCalendarClasses} />}
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onChange={(date) => setToDate(date)}
                  popperClassName={"z-10 ml-3"}
                  showIcon
                  placeholderText="Select To Date"
                />
              )}
            </Col>
            <Col
              md={24}
              lg={24}
              sm={24}
              xs={24}
              className={
                media == "sm" || media == "xs" ? "pr-2 w-[100%] mt-3" : "pr-2"
              }
            >
              <Row
                className={
                  media == "sm" || media == "xs" ? "flex" : "flex justify-end"
                }
              >
                {/* <Col
                  md={12}
                  lg={12}
                  sm={24}
                  xs={24}
                  className="pl-0 md:pl-10 lg:pl-10 xl:pl-10"
                > */}
                {loading ? (
                  <Skeleton.Input
                    style={{
                      width:
                        media == "md"
                          ? "180px"
                          : media == "sm"
                          ? "300px"
                          : "250px",
                      height: "35px",
                    }}
                  ></Skeleton.Input>
                ) : (
                  <div
                    className={
                      media == "sm" || media == "xs" ? "flex w-[100%]" : "flex"
                    }
                  >
                    <div
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                      }}
                      onClick={() => {
                        setFromDate("");
                        setToDate("");
                        setBrandList([]);
                        setModelList([]);
                        setVendorList([]);
                        dispatch(loadStockReportList(stockGetPayload));
                        setTableLoading(true);
                        setFilteredValues({
                          page: pageValue ? pageValue : 1,
                          limit: 10,
                          organizationId: organizationId,
                        });
                        setTimeout(() => {
                          setTableLoading(false);
                        }, 2000);
                      }}
                      className={
                        media == "sm" || media == "xs"
                          ? "cursor-pointer ml-0 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                          : "cursor-pointer ml-5 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                      }
                    >
                      Reset
                    </div>
                    <div
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                      }}
                      onClick={() => applyFilters()}
                      className="cursor-pointer ml-1 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 bg-[#45bd4a] hover hover:bg-[green]"
                    >
                      Filter
                    </div>
                  </div>
                )}
                {/* </Col> */}
              </Row>
            </Col>
          </Row>
        </Col>
        {/* print, download section */}
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className="bg-[#ffffff] rounded-md h-[100%]"
        >
          <Row className="flex flex-col">
            <Col md={24} lg={24} sm={24} xs={24} className="mt-4 mb-3 pb-5">
              <Row className="flex justify-between">
                <Col
                  md={10}
                  lg={10}
                  sm={24}
                  xs={24}
                  className="pr-3 lg:pr-0 md:pr-0 pl-4"
                >
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        width:
                          media == "md"
                            ? "180px"
                            : media == "sm"
                            ? "300px"
                            : "180px",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  ) : (
                    <div className="w-[100%] lg:w-[65%] md:w-[65%]">
                      <AutoComplete
                        style={{
                          marginRight: "10px",
                          fontSize: "11px",
                        }}
                        // onClick={() => setSearchOpen(false)}
                        className="w-[100%]"
                      >
                        <Input.Search
                          size="middle"
                          placeholder="Search Model"
                          style={{
                            fontFamily: "Poppins",
                            // minHeight: "35px",
                            fontSize: "11px",
                          }}
                          name="search"
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                      </AutoComplete>
                    </div>
                  )}
                </Col>
                <Col md={14} lg={14} sm={24} xs={24} className="pr-1">
                  <Row className="flex justify-end">
                    <Col
                      md={7}
                      lg={7}
                      sm={24}
                      xs={24}
                      className="pr-3 sm:pr-3 ml-3 sm:ml-3 mt-3 lg:mt-0 md:mt-0 lg:ml-10 md:ml-10"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            width:
                              media == "md"
                                ? "180px"
                                : media == "sm"
                                ? "300px"
                                : "180px",
                            paddingRight: media == "md" ? "20px" : "14px",
                            height: "35px",
                            marginLeft:
                              media == "sm" || media == "xs" ? "6px" : "",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <Row>
                          <Col
                            md={24}
                            lg={24}
                            sm={24}
                            xs={24}
                            onClick={handleDownloadPDF}
                            className={
                              media == "sm" || media == "xs"
                                ? "cursor-pointer flex justify-center border pt-[5px] pb-[5px] ml-4 mr-4 rounded-md border-1"
                                : // ? "cursor-pointer border pt-[5px] pb-[5px] ml-3 mr-2 rounded-md border-1"
                                  "cursor-pointer flex justify-center border pt-[5px] pb-[5px] rounded-md border-1"
                            }
                            style={{
                              fontFamily: "Poppins",
                            }}
                          >
                            {downloadLoading ? (
                              <p className="flex">
                                {" "}
                                <Spin className="mr-2" /> Downloading
                              </p>
                            ) : (
                              <p className="flex">
                                <DownloadOutlined className="text-[16px] mr-3" />{" "}
                                Download
                              </p>
                            )}
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col
              span={24}
              className={
                media === "xxl"
                  ? "pt-8 pl-4 purchase-invoice-orders"
                  : "pr-1 pl-4 purchase-invoice-orders"
              }
            >
              <Table
                style={{
                  overflow: "hidden",
                }}
                bordered
                columns={HeaderData}
                dataSource={
                  stockReportRows &&
                  stockReportRows.length > 0 &&
                  !isEmpty(stockReportRows[0].brandId)
                    ? stockReportRows
                    : []
                }
                rowClassName={"table-row-label p-0"}
                expandable={{
                  // expandedRowRender: expandedRowRender,
                  defaultExpandAllRows: false,
                  // expandIconColumnIndex: 5,
                }}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  onShowSizeChange: (e) => console.log(e, "page limit"),
                  pageSizeOptions: ["5", "10", "20", "30"],
                  onChange: (e) => handlePagination(e),
                  // page
                  total: !isEmpty(search)
                    ? stockReportRows.length
                    : stock_report_list
                    ? stock_report_list.totalItems
                    : "",
                }}
                sortDirections={"ascend"}
                loading={tableLoading ? true : false}
                showSorterTooltip={"sorter-icon"}
                scroll={{ y: "100%", x: 825 }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

StockDetailsReport.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
  partyName: PropTypes.any,
  ledgerLoading: PropTypes.any,
};

export default StockDetailsReport;
